import {
  Component,
} from "react";
import {
  autoUpdate,
  computePosition,
  flip,
  offset,
  shift,
  size,
} from "@floating-ui/dom";
import {
  createPortal,
} from "react-dom";

import _ from "lodash";

export default class FloatingPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      floatingStyle: {
        left: 0,
        position: "fixed",
        top: 0,
      },
    };
  }

  render() {
    const {
      open,
      renderPopup,
      renderTarget,
    } = this.props;
    const {
      floatingStyle,
    } = this.state;

    return <>
      {renderTarget(this.setReferenceRef)}
      {open && createPortal(
        renderPopup(this.setFloatingRef, floatingStyle),
        document.body,
      )}
    </>;
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.attachFloating();
    } else if (!this.props.open && prevProps.open) {
      this.detachFloating();
    } else if (this.props.open) {
      this.updateFloatingPosition();
    }
  }

  componentWillUnmount() {
    this.detachFloating();
  }

  onDocumentMouseDown = evt => {
    const {
      onClose,
    } = this.props;

    if (
      this.referenceElement && this.referenceElement.contains(evt.target)
      || this.floatingElement && this.floatingElement.contains(evt.target)
    ) {
      return;
    }

    onClose && onClose(evt);
  };

  onDocumentKeyDown = evt => {
    const {
      onClose,
    } = this.props;

    if (evt.key === "Escape" && onClose) {
      onClose(evt);
    }
  };

  setReferenceRef = element => {
    this.referenceElement = element;
    this.updateFloatingPosition();
  };

  setFloatingRef = element => {
    this.floatingElement = element;
    this.updateFloatingPosition();
  };

  attachFloating() {
    if (!this.referenceElement || !this.floatingElement) {
      return;
    }

    this.cleanupAutoUpdate = autoUpdate(
      this.referenceElement,
      this.floatingElement,
      this.updateFloatingPosition,
    );
    document.addEventListener("mousedown", this.onDocumentMouseDown);
    document.addEventListener("keydown", this.onDocumentKeyDown);
    this.updateFloatingPosition();
  }

  detachFloating() {
    if (this.cleanupAutoUpdate) {
      this.cleanupAutoUpdate();
      this.cleanupAutoUpdate = null;
    }
    document.removeEventListener("mousedown", this.onDocumentMouseDown);
    document.removeEventListener("keydown", this.onDocumentKeyDown);
  }

  updateFloatingPosition = () => {
    const {
      gutter = 4,
      placement = "bottom-start",
      shiftPadding = 8,
      strategy = "fixed",
    } = this.props;

    if (!this.referenceElement || !this.floatingElement) {
      return;
    }

    const {
      resizeToFit = false,
    } = this.props;

    const middleware = [
      offset(gutter),
      flip(),
      shift({ padding: shiftPadding }),
    ];

    if (resizeToFit) {
      middleware.push(size({
        padding: shiftPadding,
        apply: ({ availableHeight, elements }) => {
          Object.assign(elements.floating.style, {
            maxHeight: `${ availableHeight }px`,
            overflowY: "auto",
          });
        },
      }));
    }

    computePosition(this.referenceElement, this.floatingElement, {
      placement,
      strategy,
      middleware,
    }).then(({ x, y, strategy: nextStrategy }) => {
      const {
        floatingStyle,
      } = this.state;
      if (
        _.isEqual(floatingStyle, {
          left: x,
          position: nextStrategy,
          top: y,
        })
      ) {
        return;
      }

      this.setState({
        floatingStyle: {
          left: x,
          position: nextStrategy,
          top: y,
        },
      });
    });
  };
}
